import { Component } from 'solid-js';

import type { LabeledSwitchProps } from './LabeledSwitch.types';

export const LabeledSwitch: Component<LabeledSwitchProps> = (props) => {
  const handleToggleClick = (e: Event): void => {
    e.preventDefault();
    props.onToggle();
  };

  return (
    <div class="flex">
      <span
        class="whitespace-nowrap flex-1 text-base-content"
        onClick={handleToggleClick}
        textContent={props.label}
      />
      <modus-wc-switch
        size="sm"
        value={props.value}
        disabled={false}
        on:inputChange={handleToggleClick}
      />
    </div>
  );
};
